import { useState } from "react";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const ForgotPasswordStep = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const back = (
    <Button type="button" variant="ghost" onClick={onBack} data-testid="forgot-back-button" className="text-slate-400 hover:text-white hover:bg-slate-800">
      <ArrowLeft className="w-4 h-4 mr-1" /> Torna all'accesso
    </Button>
  );

  if (sent)
    return (
      <div className="space-y-6" data-testid="forgot-sent-message">
        <div className="flex gap-3 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-4">
          <MailCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-300 leading-relaxed">
            Se <span className="text-slate-100">{email}</span> è registrata, riceverai a breve un'email con il link per reimpostare la password. Il link vale 1 ora.
          </p>
        </div>
        {back}
      </div>
    );

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
      <p className="text-sm text-slate-400 leading-relaxed">Inserisci la tua email: ti invieremo un link per scegliere una nuova password.</p>
      <label className="block space-y-2">
        <span className="text-xs uppercase tracking-[0.18em] text-slate-400 font-mono">Email</span>
        <div className="relative">
          <Mail className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2 z-10" />
          <Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="nome@trustmaster.it" className="pl-10 h-11 bg-slate-900/70 border-slate-700 text-slate-100" />
        </div>
      </label>
      {error && <p className="text-sm text-rose-400" data-testid="forgot-error">{error}</p>}
      <Button data-testid="forgot-submit-button" disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white">
        {loading ? "Invio…" : "Invia link"}
      </Button>
      {back}
    </form>
  );
};
